import type { TaskWithFlags } from "@desk/contracts";
import type { TaskActions } from "@/data/actions";
import { taskRegistry } from "@/features/list/registry";
import { openCreated, ui } from "@/features/ui-state";
import { captureSelection } from "@/features/selection/selection";

/** Duplicate a task and open the copy for review. */
export async function duplicateAndOpen(a: TaskActions, task: TaskWithFlags) {
  const hash = window.location.hash;
  const { openTaskId, detailVia } = ui.get();
  const ownsSelection = captureSelection();
  const id = await a.duplicate(task);
  if (id && window.location.hash === hash && ui.get().openTaskId === openTaskId && ui.get().detailVia === detailVia && ownsSelection())
    openCreated(id, (x) => taskRegistry.has(x));
}
